import styled from 'styled-components/macro';

export const TextEllipsisTooltip = styled.div<{
  height?: string;
  leftAfter?: string;
  bottomAfter?: string;
  leftBefore?: string;
  topBefore?: string;
  display?: boolean;
  positionRight?: string;
}>`
  display: flex;
  position: relative;
  cursor: pointer;
  height: ${({ height }) => height && `${height}`};
  ${({ positionRight }) => positionRight && `right: ${positionRight}`};

  :hover::before {
    ${({ display }) => (display ? ` content: ' ' ` : `content: none`)};
    border-width: 10px;
    border-style: solid;
    border-color: ${({ theme }) => theme.colors.black_100} transparent transparent transparent;
    position: absolute;
    top: ${({ topBefore }) => (topBefore ? `${topBefore}` : '2px')};
    left: ${({ leftBefore }) => (leftBefore ? `${leftBefore}` : '50%')};
    transform: translate(-50%, -50%);
  }

  :hover::after {
    position: absolute;
    ${({ display }) => (display ? ` content: attr(data-tooltip) ` : `content: none`)};
    padding: ${({ theme }) => theme.spacing.zero_2};
    border-radius: ${({ theme }) => theme.spacing.zero_2};
    left: ${({ leftAfter }) => (leftAfter ? `${leftAfter}` : '0')};
    bottom: ${({ bottomAfter }) => (bottomAfter ? `${bottomAfter}` : '120%')};
    white-space: nowrap;
    z-index: 1;
    background-color: ${({ theme }) => theme.colors.black_100};
    color: ${({ theme }) => theme.colors.white};
    letter-spacing: ${({ theme }) => theme.letterSpacing.md};
    font-size: ${({ theme }) => theme.fontSize.xxs} !important;
    line-height: 1.33;
    text-align: center;
    box-shadow: 0 2px 10px -2px rgba(37, 40, 43, 0.2);
  }
`;

export const TextEllipsisTooltipContent = styled.p<{ maxWidth?: string }>`
  ${({ maxWidth }) =>
    maxWidth ? ` max-width: ${maxWidth} ` : ` max-width: 100px`}; // length of ellipsis text
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
`;

export const TextEllipsisNoTooltip = styled.p`
  :hover {
    cursor: pointer;
  }
`;
